import { useMutation, useQuery, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { axiosInstance } from "../../axios/axiosInstance";
import { ReportReason } from "./useSellerListings";

export interface ModerationListing {
  id: number;
  title: string;
  regionName: string | null;
  price: number;
  isHidden: boolean;
  hiddenReason: string | null;
  createdDate: string;
  openReportCount: number;
  reports: { reason: ReportReason; comment: string | null; createdDate: string }[];
}

export function useIsModerator(enabled: boolean) {
  return useQuery("ModerationMe", async () => (await axiosInstance.get("/api/Moderation/me")).data as { isAdmin: boolean }, {
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  });
}

export function useModerationListings(enabled: boolean) {
  return useQuery("ModerationListings", async () => (await axiosInstance.get("/api/Moderation/listings")).data as ModerationListing[], {
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function useModerate() {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ id, action, reason }: { id: number; action: "hide" | "restore"; reason?: string }) =>
      axiosInstance.put(`/api/Moderation/listings/${id}/${action}`, action === "hide" ? { reason } : undefined),
    {
      onSuccess: () => queryClient.invalidateQueries("ModerationListings"),
      onError: () => {
        enqueueSnackbar("Nie udało się zapisać decyzji.", { variant: "error" });
      },
    }
  );
}
